import HubIcon from '@mui/icons-material/Hub'
import { FC } from 'react'
import {
  Create
} from 'react-admin'
import { ActionsToolbar } from '../../components'
import CollaborationsForm from './CollaborationsForm'

const CollaborationsCreate: FC = () => (
  <Create
    actions={<ActionsToolbar startIcon={<HubIcon />} i18n="resources.collaborations.create" />}
    redirect="show"
  >
    <CollaborationsForm />
  </Create>
)

export default CollaborationsCreate
